import * as React from 'react';
import styled from 'styled-components';

export interface CaseReportEventEvidenceItemProps {
  fileName: string;
  link: string;
  type: 'image' | 'document';
  index: number;
}

export const CaseReportEventEvidenceItem: React.FC<
  CaseReportEventEvidenceItemProps
> = ({ fileName, link, type, index, ...props }) => {
  return (
    <CaseReportEventEvidenceItemContainer
      href={link}
      target="_blank"
      index={index}
      {...props}
    >
      {type === 'document' ? (
        <DocumentPreviewContainer>
          <DocumentPreview
            src="/assets/document_preview.png"
            alt="Pdf attachment"
          />
        </DocumentPreviewContainer>
      ) : (
        <ImagePreviewContainer>
          <ImagePreview
            src="/assets/image_preview.png"
            alt="Image attachment"
          />
        </ImagePreviewContainer>
      )}
      <FileName index={index}>{fileName}</FileName>
    </CaseReportEventEvidenceItemContainer>
  );
};

const CaseReportEventEvidenceItemContainer = styled.a<{ index: number }>`
  max-width: 100px;
  display: flex;
  align-items: ${(props) => (props.index === 0 ? 'flex-start' : 'center')};
  margin: 0 32px 0 0;
  flex-direction: column;
  align-content: center;
  text-decoration: none;
`;

const DocumentPreviewContainer = styled.div`
  width: 61px;
  height: 78px;
  display: flex;
  align-items: flex-end;
`;

const DocumentPreview = styled.img`
  width: 100%;
  height: auto;
  filter: drop-shadow(0px 1.5px 5.32px rgba(0, 0, 0, 0.2));
`;

const ImagePreviewContainer = styled.div`
  width: 81px;
  height: 78px;
  display: flex;
  align-items: flex-end;
`;

const ImagePreview = styled.img`
  width: 100%;
  height: auto;
  filter: drop-shadow(0px 1.5px 4px rgba(0, 0, 0, 0.15));
  border-radius: 3px;
`;

const FileName = styled.div<{ index: number }>`
  font-family: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.typography.fontFamily
      : props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  font-size: 8px;
  margin: 9px 0 0 0;
  width: 100%;
  overflow-wrap: break-word;
  text-align: ${(props) => (props.index === 0 ? 'left' : 'center')};
`;
